// store/schoolSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const createSchool = createAsyncThunk(
  'school/create',
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post('http://localhost:3000/api/schools', formData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateSchool = createAsyncThunk(
  'school/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`http://localhost:3000/api/schools/${id}`, formData);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchSchools = createAsyncThunk(
  'school/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get('http://localhost:3000/api/schools');
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const schoolSlice = createSlice({
  name: 'school',
  initialState: {
    schools: [],
    school: null,
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetSchoolState(state) {
      state.success = false;
      state.error = null;
      state.school = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createSchool.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createSchool.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = true;
        state.schools.unshift(action.payload);
      })
      .addCase(createSchool.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to create school';
      })
      .addCase(updateSchool.fulfilled, (state, action) => {
        state.success = true;
        state.schools = state.schools.map((s) =>
          s.id === action.payload.id ? action.payload : s
        );
      })
      .addCase(fetchSchools.fulfilled, (state, action) => {
        state.schools = action.payload;
      });
  },
});

export const { resetSchoolState } = schoolSlice.actions;
export default schoolSlice.reducer;
